import { combineReducers } from '@reduxjs/toolkit';
import { createRouterReducer } from '@lagunovsky/redux-react-router';

import { history } from '@xarvio/frontend-core-platform/lib/browserHistory';
import featureFlagsSlice from './featureFlags/featureFlagsSlice';
import { uiSlice } from './ui/uiSlice';
import { selectedFieldsSlice } from './selectedFields/selectedFieldsSlice';
import { LOADER_SLICE_DEFAULT_NAME, loaderSlice } from '@xarvio/elements';
import { TOAST_SLICE_DEFAULT_NAME, toastSlice } from '@xarvio/toast';

import authSlice from './auth/authSlice';
import intlSlice from './intl/intlSlice';
import usersReducer from './users/reducer';
import { selectedFarmSlice } from './selectedFarm/selectedFarmSlice';

export const rootReducer = combineReducers({
  router: createRouterReducer(history),
  auth: authSlice.reducer,
  featureFlags: featureFlagsSlice.reducer,
  users: usersReducer,
  intl: intlSlice.reducer,
  selectedFarm: selectedFarmSlice.reducer,
  ui: uiSlice.reducer,
  selectedFields: selectedFieldsSlice.reducer,
  [LOADER_SLICE_DEFAULT_NAME]: loaderSlice.reducer,
  [TOAST_SLICE_DEFAULT_NAME]: toastSlice.reducer,
});

export type RootReducer = typeof rootReducer;
